import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { CSS_CLASS_PREFIX } from "../constants/css";
import Currency from "./Currency";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";

const Container = styled.span``;

const CurrencyWrapper = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    .${CSS_CLASS_PREFIX}-currency * {
      color: ${p => p.theme.monthlyFee.currencyColor};
    }
  }
`;

const MonthlyFeeWrapper = styled.span``;
const StandardMonthlyFeeWrapper = styled.span``;
const PromotionTermTextWrapper = styled.span``;

const PeriodWrapper = styled.span``;

class MonthlyFee extends PureComponent {
  render() {
    const {
      monthlyFee,
      portal,
      promotionTerm,
      contractTermInMonths,
      standardMonthlyFee,
      t
    } = this.props;

    return (
      <Container>
        <MonthlyFeeWrapper className={`${CSS_CLASS_PREFIX}-monthly-fee`}>
          <CurrencyWrapper
            className={`${CSS_CLASS_PREFIX}-monthly-fee-currency`}
          >
            <Currency amount={monthlyFee} portal={portal} replaceZeros={true} />
          </CurrencyWrapper>{" "}
          <PeriodWrapper className={`${CSS_CLASS_PREFIX}-monthly-fee-text`}>
            {this.perMonthText()}
          </PeriodWrapper>
        </MonthlyFeeWrapper>
        {promotionTerm != null &&
          contractTermInMonths != null &&
          promotionTerm !== contractTermInMonths &&
          monthlyFee !== standardMonthlyFee && (
            <StandardMonthlyFeeWrapper
              className={`${CSS_CLASS_PREFIX}-standard-monthly-fee`}
            >
              <PromotionTermTextWrapper className={`${CSS_CLASS_PREFIX}-promotion-term-text`}>
                {" "}
                {t("afterMonths", {
                  monthCount: promotionTerm
                })}{" "}
              </PromotionTermTextWrapper>
              <CurrencyWrapper
                className={`${CSS_CLASS_PREFIX}-standard-monthly-fee-currency`}
              >
                <Currency
                  amount={standardMonthlyFee}
                  portal={portal}
                  replaceZeros={true}
                />
              </CurrencyWrapper>{" "}
              <PeriodWrapper
                className={`${CSS_CLASS_PREFIX}-standard-monthly-fee-text`}
              >
                {this.perMonthText()}
              </PeriodWrapper>
            </StandardMonthlyFeeWrapper>
          )}
      </Container>
    );
  }

  perMonthText() {
    const { short, t } = this.props;

    if (short) {
      return t("perMonthShort");
    } else {
      return t("perMonth");
    }
  }
}

MonthlyFee.propTypes = {
  contractTermInMonths: PropTypes.number,
  monthlyFee: PropTypes.number.isRequired,
  portal: PropTypes.object.isRequired,
  promotionTerm: PropTypes.number,
  short: PropTypes.bool,
  standardMonthlyFee: PropTypes.number
};

export default withTranslation(["monthlyFee"])(MonthlyFee);
